/**
 * Created by Bob.Gear on 11/03/14.
 */
//------------------------------------------------------------------------
//  contractorNameFilter Directive
//------------------------------------------------------------------------
angular.module("EICDataStream3.queryBuilder")
    .controller('contractorNameFilterController', ['$scope', '$http',
      function ($scope, $http) {
        $scope.componentName = "contractorNameFilter";


        $scope.resetFilter = function(){
          $scope.clearContractorName();
        };

        $scope.clearContractorName = function () {
          delete $scope.criteria["selectedContractTypes"];
          //$scope.criteria.contractorName = "";
        };

        $scope.removeContractorNameFilter = function () {
          $scope.resetFilter();
          $scope.$parent.removeFilter("#contractorNameFilter");
        };

        // Contractor Name autocomplete function
        var autocompleteContractorName = function (request, response) {
              var callback = function (data) {
                var list = [];
                for (var i = 0; i < data.length; i++) {
                  var thisItem = {
                    label: data[i].name,
                    value: data[i].name
                  };

                  list.push(thisItem);
                }
                response(list);
              };

              $http.get("/api/companyname?limit=11&q=" + JSON.stringify($scope.criteria))
                  .then(callback)
                  .catch(function (data, status, headers, config) {
                    // called asynchronously if an error occurs
                    // or server returns response with an error status.
                  });
            },
            _renderItem = function (ul, item) {
              if (ul.children().length < 10) {
                return $("<li class='ui-menu-item' role='presentation'>")
                    .data("item.autocomplete", item)
                    .append("<a class='ui-corner-all' tabindex='-1'>" + item.label + "</a>")
                    .appendTo(ul);
              }
              else {
                return $("<li class='ui-menu-item' style=color:red;text-align:center;' role='presentation'>more results are available with a more specific search</li>")
                    .appendTo(ul);
              }


            },
            select = function (event, ui) {
              if (ui.item) {
                $scope.criteria.contractorName = ui.item.label;
              }
            };
        $scope.contractorNameAutocompleteOptions = {
          minLength:   2,
          source:      autocompleteContractorName,
          select:      select,
          delay:       500,
          _renderItem: _renderItem
        };
        //------------------------------------------------------------------------

      }])
    .directive('contractorNameFilter', ['$compile',
      function ($compile) {
        return {
          replace:     true,  // replace the placeholder element with the template
          restrict:    'A',   // usage: <div projectNameFilter />
          templateUrl: "../app-ds3/search/queryBuilder/filters/contractorNameFilter.tmpl.html",

          link: function ($scope, iElement, iAttrs) {
          },

          controller: 'contractorNameFilterController'
        };
      }]);
//------------------------------------------------------------------------
